export default "__VITE_ASSET__Bho5JWAp__"